<!--
 * @Author: DY
 * @Date: 2024-11-21 14:41:15
 * @LastEditTime: 2026-07-28 15:25:57
 * @Description: 库存查询列表
 * @FilePath: \ShiMoMobile\src\views\storage\inventoryInquiry\index_new.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="inventoryInquiry_new">
            <header>
                <button class="returnBtn iconfont sm-fanhui" @click="swiperright"></button>
                <ul>
                    <template v-for="(item, index) in timePeriod">
                        <li :key="`timePeriod_${index}`" :class="{'active': currentTimeIndex === index}" @click="selectTimePeriod(index)">
                            {{ item.name }}
                        </li>
                    </template>
                </ul>
                <div class="timePeriod" @click="selectCalendarTime">
                    <div class="iconfont sm-rili">
                        <input type="datetime" readonly v-model="formData.StartTime">
                    </div>
                    <span>至</span>
                    <div class="iconfont sm-rili">
                        <input type="datetime" readonly v-model="formData.EndTime">
                    </div>
                </div>
            </header>
            <section>
                <div class="queryTimeNode">
                    <i class="iconfont sm-rili"></i>
                    <p>查询范围:{{ searchScope }}</p>
                </div>
                <div class="queryConditions">
                    <div class="queryList iconfont sm-cangkukucun">
                        <input type="datetime" placeholder="搜索仓库名称..." v-model="formData.StockName" @input="loadTableData">
                    </div>
                    <div class="queryList iconfont sm-saoma-big">
                        <input type="datetime" placeholder="搜索物料代码或描述..." v-model="formData.MaterialCodeName" @input="loadTableData">
                    </div>
                </div>
                <ul class="totalInventory">
                    <li>
                        <h5>当前库存合计</h5>
                        <p>{{ totalData.VolumeCurrent }}</p>
                    </li>
                    <li>
                        <h5>期初库存合计</h5>
                        <p>{{ totalData.PeriodStartVolume }}</p>
                    </li>
                    <li>
                        <h5>期间入库合计</h5>
                        <p>{{ totalData.PeriodInstock }}</p>
                    </li>
                    <li>
                        <h5>期间出库合计</h5>
                        <p>{{ totalData.PeriodOutstock }}</p>
                    </li>
                    <li>
                        <h5>期末库存合计</h5>
                        <p>{{ totalData.PeriodEndVolume }}</p>
                    </li>
                </ul>
                <div class="listInventory">
                    <table>
                        <thead>
                            <tr>
                                <th rowspan="2">
                                    仓库名称
                                </th>
                                <th rowspan="2">
                                    物料代码
                                </th>
                                <th rowspan="2">
                                    短描述
                                </th>
                                <th rowspan="2">
                                    单位
                                </th>
                                <th>当前库存</th>
                                <th>期初库存</th>
                                <th class="color1">
                                    期间入存
                                </th>
                                <th class="color2">
                                    期间出库
                                </th>
                                <th>期末库存</th>
                            </tr>
                            <tr>
                                <th>数量</th>
                                <th>数量</th>
                                <th>数量</th>
                                <th>数量</th>
                                <th>数量</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(item, index) in tabeData">
                                <tr :key="`list_${index}`">
                                    <td>{{ item.StockName }}</td>
                                    <td>{{ item.MaterialCode }}</td>
                                    <td>{{ item.MaterialShortName }}</td>
                                    <td>{{ item.Unit }}</td>
                                    <td class="color3">
                                        {{ item.VolumeCurrent }}
                                    </td>
                                    <td class="color3">
                                        {{ item.PeriodStartVolume }}
                                    </td>
                                    <td class="color1">
                                        {{ item.PeriodInstock }}
                                    </td>
                                    <td class="color2">
                                        {{ item.PeriodOutstock }}
                                    </td>
                                    <td class="color3">
                                        {{ item.PeriodEndVolume }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </section>
            <footer>共{{ totalNub }}条数据</footer>
            <van-calendar v-model="showCalendar" type="range" :default-date="defaultDate" :min-date="minDate" @confirm="onConfirm"></van-calendar>
        </div>
    </v-touch>
</template>

<script>
import currencyFun from '@/assets/js/currencyFun/index.js';
export default {
    name: 'inventory-inquiry',
    mixins: [],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'inventory-inquiry');
        }
        next();
    },
    data() {
        return {
            timePeriod: [{
                name: '按日',
                key: 1,
            }, {
                name: '按自然月',
                key: 2,
            }, {
                name: '按财务月',
                key: 3,
            }, {
                name: '按年',
                key: 4,
            }],
            currentTimeIndex: 1,
            showCalendar: false,
            minDate: new Date(2000, 0, 1),
            defaultDate: [],
            formData: {
                MaterialCategory: [],
                timePeriod: [],
                StartTime: '',
                EndTime: '',
                StockName: '',
                MaterialCodeName: '',
                PageIndex: 1,
                PageSize: 999,
            },
            searchScope: '',
            tabeData: [],
            totalData: {},
            totalNub: '',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    created() {
        // 参数 0横向 1竖向
        window.$globalHub.$callMobile('JYTeamsNative', 'setScreenOrientation', 0);
        const menuType = this.$route.query.menuType;
        if (menuType === 'kccx') {
            this.formData.MaterialCategory = null;
        } else if (menuType === 'ccpkc') {
            this.formData.MaterialCategory = [2];
        }
        this.formData.timePeriod = currencyFun.prevMonthFull({ fmt: 'yyyy-MM-dd' });
        this.formData.StartTime = this.formData.timePeriod[0];
        this.formData.EndTime = this.formData.timePeriod[1];
        this.searchScope = `${this.formData.StartTime} ~ ${this.formData.EndTime}`;
        this.loadTableData();
    },
    mounted() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'home' });
        },
        selectTimePeriod(index) {
            this.currentTimeIndex = index;
            if (this.currentTimeIndex === 0) {
                const time = currencyFun.nowDay();
                this.formData.StartTime = time[0];
                this.formData.EndTime = time[1];
                this.searchScope = `${this.formData.StartTime} ~ ${this.formData.EndTime}`;
            } else if (this.currentTimeIndex === 1) {
                const time = currencyFun.nowMonth();
                this.formData.StartTime = time[0];
                this.formData.EndTime = time[1];
                this.searchScope = `${this.formData.StartTime} ~ ${this.formData.EndTime}`;
            } else if (this.currentTimeIndex === 2) {
                const time = currencyFun.nowMonth_customize({ fmt: 'yyyy-MM-dd', startDate: 25 });
                this.formData.StartTime = time[0];
                this.formData.EndTime = time[1];
                this.searchScope = `${this.formData.StartTime} ~ ${this.formData.EndTime}`;
            } else if (this.currentTimeIndex === 3) {
                const time = currencyFun.currentYearToPresent();
                this.formData.StartTime = time[0];
                this.formData.EndTime = time[1];
                this.searchScope = `${this.formData.StartTime} ~ ${this.formData.EndTime}`;
            }
            this.loadTableData();
        },
        selectCalendarTime() {
            this.defaultDate = [new Date(this.formData.StartTime), new Date(this.formData.EndTime)];
            this.showCalendar = true;
        },
        onConfirm(date) {
            const [start, end] = date;
            this.showCalendar = false;
            this.formData.StartTime = currencyFun.timeFormat(start, 'yyyy-MM-dd');
            this.formData.EndTime = currencyFun.timeFormat(end, 'yyyy-MM-dd');
            this.searchScope = `${this.formData.StartTime} ~ ${this.formData.EndTime}`;
            this.loadTableData();
        },
        async loadTableData() {
            const res = await this.getTabeData(this.formData);
            this.tabeData = res.rows;
            this.totalNub = res.total;
            this.totalData = await this.gettotalData(this.formData);
        },
        getTabeData(data) {
            return this.$axios.$post('/interfaceApi/procurement/stock_material_inout_log/statistics_page', data);
        },
        gettotalData(data) {
            return this.$axios.$post('/interfaceApi/procurement/stock_material_inout_log/statistics_total', data);
        },
    },
    beforeDestroy() {
        window.$globalHub.$callMobile('JYTeamsNative', 'setScreenOrientation', 1);
    },
};
</script>
<style lang="stylus">
.inventoryInquiry_new
    height 100%
    padding-top 3vmin
    input
        font-size 3.6vmin
        border 2px solid #d4d8dd
        border-radius 1.5vmin
        height 10vmin
        line-height 10vmin
    header
        height 14vmin
        display flex
        gap 2vmin
        padding 4vmin 4vmin 0
        .returnBtn
            width 10vmin
            border 2px solid #d4d8dd
            border-radius 1.5vmin
            background #FFF
        ul
            display flex
            align-items center
            background #f2f3f4
            border-radius 1.5vmin
            padding 0.8vmin
            li
                height 100%
                padding 0 5vmin
                border-radius 1.5vmin
                display flex
                align-items center
                font-size 3.6vmin
                &.active
                    background #fff
        .timePeriod
            display flex
            align-items center
            margin-left auto
            gap 2vmin
            div
                position relative
                &:before
                    display flex
                    align-items center
                    height calc(10vmin - 4px)
                    position absolute
                    right 2vmin
                    font-size 4vmin
            input
                width 18vw
                text-indent 2vmin
    section
        height calc(100% - 24vmin)
        overflow-y auto
        display flex
        flex-direction column
        padding 2vmin 4vmin
        gap 2vmin
        .queryTimeNode
            flex none
            height 9vmin
            background #f0f5fe
            border 2px solid #dfe8fc
            border-radius 1.5vmin
            display flex
            align-items center
            justify-content center
            gap 1vmin
            .iconfont
                font-size 4.4vmin
            p
                font-size 3.6vmin
        .queryConditions
            display flex
            gap 2vmin
            .queryList
                height 10vmin
                flex 1
                position relative
                &:before
                    height 10vmin
                    line-height 10vmin
                    font-size 4vmin
                    position absolute
                    left 3vmin
                input
                    width 100%
                    text-indent 8vmin
        .totalInventory
            flex none
            display flex
            align-items center
            height 16vmin
            gap 2vmin
            li
                height 100%
                flex 1
                display flex
                align-items center
                flex-direction column
                border-radius 1.5vmin
                justify-content center
                &:nth-of-type(1)
                    border 1px solid #e1ebfd
                    background #f1f6fe
                    h5
                        color #5b71cf
                    p
                        color #192a76
                &:nth-of-type(2)
                    border 1px solid #f1f3f3
                    background #f8f9fa
                    h5
                        color #535457
                    p
                        color #22272f
                &:nth-of-type(3)
                    border 1px solid #e2f4e6
                    background #f2faf3
                    h5
                        color #4d8b44
                    p
                        color #488441
                &:nth-of-type(4)
                    border 1px solid #f6e6e6
                    background #faf2f3
                    h5
                        color #a7261e
                    p
                        color #822c24
                &:nth-of-type(5)
                    border 1px solid #e1e4fd
                    background #eef1fe
                    h5
                        color #3e4ad1
                    p
                        color #302b74
                h5
                    font-size 3vmin
                    line-height 3vmin
                    margin-bottom 2vmin
                p
                    font-size 5vmin
                    line-height 5vmin
                    font-weight bold
        .listInventory
            table
                width 100%
                border-collapse: collapse;
                border-radius 1.5vmin
                th,td
                    border 1px solid #e3e5e8
                    font-size 3vmin
                    line-height 8vmin
                    text-align center
                thead
                    th
                        background #f8f9fb
                        color #2c323e
                        font-weight 400
                tbody
                    td
                        color #30333f
                .color1
                    color #489040
                .color2
                    color #c1544d
                .color3
                    color #405ad1
    footer
        height 10vmin
        font-size 4vmin
        line-height 10vmin
        background #f7f8fa
        color #6e7582
        text-align center
    .van-calendar__popup
        height 84%
</style>
